import { Component, OnInit} from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import { LinkService } from '../../../../_services/langhfre.service';
import { NavigationService } from 'src/app/_services/navigation.service';
//declare function ire(string,{}): any;

@Component({
  selector: 'app-how-we-do-it',
  templateUrl: './how-we-do-it.component.html',
  styleUrls: ['./how-we-do-it.component.scss']
})
export class HowWeDoItComponent implements OnInit {

  constructor(
    private titleService: Title,
    private metaTagService: Meta,
    private LinkService: LinkService,
    public navigationService: NavigationService
  ) {
  }

  ngOnInit() {
    this.titleService.setTitle('How We Build Custom AI Models | Custom AI Solutions by Trinka');
    this.metaTagService.updateTag({ name: 'description', content: "Discover how Trinka AI builds custom AI models for enterprises. We develop models that are precise, aligned with your business goals, and built using your proprietary data." });
    this.metaTagService.updateTag({ property: 'og:title', content: "How We Build Custom AI Models | Custom AI Solutions by Trinka" });
    this.metaTagService.updateTag({ property: 'og:description', content: "Discover how Trinka AI builds custom AI models for enterprises. We develop models that are precise, aligned with your business goals, and built using your proprietary data." });
    this.metaTagService.updateTag({ property: 'og:url', content: 'https://www.trinka.ai/enterprise/custom-ai-models/how-we-do-it' });
    this.metaTagService.updateTag({ property: 'og:type', content: 'website' });
    this.metaTagService.updateTag({ property: 'og:image', content: 'https://www.trinka.ai/assets/images/Trinka.jpg' });
    this.metaTagService.updateTag({ name: 'language', content: 'en-us' });
    this.LinkService.addTag({ rel: 'canonical', href: 'https://www.trinka.ai/enterprise/custom-ai-models/how-we-do-it' });
    this.metaTagService.updateTag({ name: 'twitter:title', content: 'How We Build Custom AI Models | Custom AI Solutions by Trinka' });
    this.metaTagService.updateTag({ name: 'twitter:description', content: "Discover how Trinka AI builds custom AI models for enterprises. We develop models that are precise, aligned with your business goals, and built using your proprietary data." });
    this.metaTagService.updateTag({ name: 'twitter:image', content: 'https://www.trinka.ai/assets/images/Trinka.jpg' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'x-default', href: 'https://www.trinka.ai/enterprise/custom-ai-models/how-we-do-it' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'en-us', href: 'https://www.trinka.ai/enterprise/custom-ai-models/how-we-do-it' });

    //ire('identify', { 'customerId': '', customerEmail: '', customProfileId: '' });
    // console.log("Country is", this.country);
  }

}
